var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 224v72h-32v192h-48l-8-88-8 88h-48V296h-32v-72a32 32 0 0132-32h112a32.026 32.026 0 0130.84 23.42A32.366 32.366 0 01488 224z",
    fill: "#4d5e78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M488 224v72h-32v192h-48l-8-88-8 88h-48V357.58a459.486 459.486 0 00142.84-142.16A32.366 32.366 0 01488 224z",
    fill: "#485870"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376 192l24 40 24-40z",
    fill: "#e0e0de"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#404f66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392 232h16v136h-16zM424 248h32v16h-32zM344 248h32v16h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 232h16v88h-16zM448 232h16v88h-16z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M400.147 192a56 56 0 01-56-56V80a24 24 0 0124-24h64a24 24 0 0124 24v56a56 56 0 01-56 56z",
    fill: "#fec9a3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M456 88H344V56a32 32 0 0132-32h48a32 32 0 0132 32z",
    fill: "#404f66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M448 112h-5.117a88.356 88.356 0 01-21.441-2.64 88.42 88.42 0 00-42.884 0 88.356 88.356 0 01-21.441 2.64H352a16 16 0 01-16-16 16 16 0 0116-16h96a16 16 0 0116 16 16 16 0 01-16 16z",
    fill: "#4d5e78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M400 168a24.027 24.027 0 01-24-24h16a8 8 0 0016 0h16a24.027 24.027 0 01-24 24z",
    fill: "#f7ad7c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M368 112h16v16h-16zM416 112h16v16h-16z",
    fill: "#92563a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M344 368h112v16H344z",
    fill: "#404f66"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M448 256l-72 40h112v-24z",
    fill: "#feb784"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M376 296l-24-16-40 16v40h152a24 24 0 0024-24v-16z",
    fill: "#fec9a3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24 240h40v88H48a24 24 0 01-24-24v-64z",
    fill: "#fec093"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108 24a68 68 0 0168 68v124H40V92a68 68 0 0168-68z",
    fill: "#92563a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.147 56h64a24 24 0 0124 24v48a56 56 0 01-56 56 56 56 0 01-56-56V80a24 24 0 0124-24z",
    fill: "#fec9a3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40 120l13.171-1.646A126.1 126.1 0 00136 72l32 40 8-16v-8a64 64 0 00-64-64h-10.388a61.612 61.612 0 00-38.489 13.5A61.615 61.615 0 0040 85.612z",
    fill: "#92563a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64 440h48v48H64zM112 440h48v48h-48z",
    fill: "#fec9a3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64 224l-3.716 3.716A34.692 34.692 0 0064 280v16h96v-16a34.692 34.692 0 003.716-52.284L160 224z",
    fill: "#f59898"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M200 216v24h-40v56H64v-56H24v-24a32 32 0 0132-32h112a32.006 32.006 0 0132 32zM184 440H40l20.93-125.59L64 296h96z",
    fill: "#f59898"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M184 440H40l20.93-125.59Q74.3 305.74 87.25 296H160zM200 216v24h-40v56H87.25a457.112 457.112 0 00101.03-104.75A31.924 31.924 0 01200 216z",
    fill: "#ed9191"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M192 392h-24a8 8 0 01-8-8V240h40v144a8 8 0 01-8 8zM80 184l32 64 32-64z",
    fill: "#fec9a3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M112.147 160a24.027 24.027 0 01-24-24h16a8 8 0 0016 0h16a24.027 24.027 0 01-24 24z",
    fill: "#f7ad7c"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M80.147 104h16v16h-16zM128.147 104h16v16h-16z",
    fill: "#92563a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64 240h104v128H64z",
    fill: "#ffb531"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M168 336H48a24 24 0 01-24-24v-16h88l24-24 16 8-8 16h24zM224 48h64a24 24 0 0124 24v56a56 56 0 01-56 56 56 56 0 01-56-56V72a24 24 0 0124-24z",
    fill: "#fec9a3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M312 104l-24-40-11.645 3.882a100.79 100.79 0 01-71.578-2.982 21.313 21.313 0 01-10.668-29.122A21.314 21.314 0 01213.173 24H280a32 32 0 0132 32z",
    fill: "#f98500"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M344 216v72h-32v72H200v-72h-32v-72a32 32 0 0132-32h112a31.955 31.955 0 0132 32z",
    fill: "#cfcfcd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M344 216v72h-32v72H200v-39.82c51.67-27.49 100.6-65.15 141.96-115.46A31.973 31.973 0 01344 216z",
    fill: "#c7c7c5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M256 152a24.027 24.027 0 01-24-24h16a8 8 0 0016 0h16a24.027 24.027 0 01-24 24z",
    fill: "#f7ad7c"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M224 96h16v16h-16zM272 96h16v16h-16z",
    fill: "#92563a"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M192 224h16v88h-16zM304 224h16v88h-16z",
    fill: "#b0b0ae"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M240 184l8 24-8 104 16 16 16-16-8-104 8-24z",
    fill: "#348fd9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M312 488h-48l-8-96-8 96h-48V360h112z",
    fill: "#4d5e78"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M216 288l84.845 38.566a16 16 0 006.621 1.434H328a16 16 0 0016-16v-24l-112-32z",
    fill: "#dbdbd9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M216 288h-48v-40h40l24 8z",
    fill: "#fec9a3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M296 288l-84.845 38.566a16 16 0 01-6.621 1.434H184a16 16 0 01-16-16v-24l112-32z",
    fill: "#e0e0de"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M296 288h48v-40h-40l-24 8z",
    fill: "#fec9a3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M64 440h96v16H64z",
    fill: "#fec093"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104 440h16v48h-16z",
    fill: "#feb784"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M200 360h112v16H200z",
    fill: "#485870"
  })));
}

export default __webpack_public_path__ + "1cd9b55175304e278327fa0ba05e7946.svg";
export { SvgTeam as ReactComponent };